import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

// Primary account (new)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

// TODO(firebase-migration): remove legacy account once the scanning app has moved to the new account
const legacyDatabaseURL = import.meta.env.VITE_LEGACY_FIREBASE_DATABASE_URL;
const legacyConfig = {
  apiKey: import.meta.env.VITE_LEGACY_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_LEGACY_FIREBASE_AUTH_DOMAIN,
  databaseURL: legacyDatabaseURL,
  projectId: import.meta.env.VITE_LEGACY_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_LEGACY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_LEGACY_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_LEGACY_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_LEGACY_FIREBASE_MEASUREMENT_ID
};
const legacyApp = legacyDatabaseURL ? initializeApp(legacyConfig, 'legacy') : null;
const legacyAuth = legacyApp ? getAuth(legacyApp) : null;
const legacyDatabase = legacyApp ? getDatabase(legacyApp) : null;

export { auth, database, legacyAuth, legacyDatabase };
